module.exports = __webpack_public_path__ + "static/img/10001 (3).c2b3fb3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10001 (3).webp
// module id = hfcJ
// module chunks = 14